import { Component } from "@angular/core";

@Component({
	moduleId: module.id,
	selector: "pageNotFound",
	styleUrls: ["pageNotFound.css"],
	templateUrl: "pageNotFound.html"
})
export class PageNotFoundComponent {}